module.exports = __webpack_public_path__ + "static/media/workifit.c1ab2224.png";